namespace Areas.Budget.View {
    "use strict";


    var tabItems = Areas.createTabsWithSameAction("Budget", "View",
        ["Profile", "BudgetEntry", "UnLinked", "Linked", "AutoLinked", "Summary", "Detail", "Filter", "Reclass", "Memos"]);

    export function tabInitialized(params: any) {
        return Areas.tabWithIdInitialized(tabItems)(params);
    }

}
